export default __webpack_public_path__ + "static/supabase-signup-flow-3fc520958922da6d01688dbb33ce2c41.gif";